/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum NutritionnalValueTypeEnum {
  Protein = 'Protein',
  Carbohydrates = 'Carbohydrates',
  Sugar = 'Sugar',
  Lipids = 'Lipids',
  SaturatedFattyAcids = 'SaturatedFattyAcids',
  Fibers = 'Fibers',
  Salt = 'Salt',
  Iron = 'Iron',
  Calcium = 'Calcium',
}
